import { render } from "./EmptySpace.vue?vue&type=template&id=0bc45ae8&scoped=true"
import script from "./EmptySpace.vue?vue&type=script&lang=js"
export * from "./EmptySpace.vue?vue&type=script&lang=js"

import "./EmptySpace.vue?vue&type=style&index=0&id=0bc45ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc45ae8"]])

export default __exports__